import { ObservableCascadeQueue as CascadeQueue } from './observable-cascade-queue';
import { v4 as uuid } from 'uuid';
import { ObservableInput, Observable, from, of } from 'rxjs';
import { takeWhileInclusive } from 'rxjs-take-while-inclusive';
import { filter, map, catchError } from 'rxjs/operators';
import { ToggleEventTypes } from './toggle-events';

export class ToggleQueue {
  private _queues = new Map<
    string,
    CascadeQueue<{ origin: any; id: string }>
  >();

  get(queue_id: string) {
    let queue = this._queues.get(queue_id);
    if (!queue) {
      queue = new CascadeQueue<any>();
      this._queues.set(queue_id, queue);
      // queue.asObservable().subscribe(e=>console.log(e.origin.option.text, e.origin.checking, e.origin.type));
    }
    return queue;
  }
  destroy(queue_id: string = undefined) {
    this._queues.forEach((queue, iterated_id) => {
      if (typeof queue_id === 'undefined' || queue_id === iterated_id) {
        queue.destroy();
      }
    });
  }
  add(
    queue_id: string,
    item: ObservableInput<any>,
    job_id: string = uuid()
  ): Observable<any> {
    let job = this.get(queue_id)
      .add(
        from(item).pipe(
          map(event => {
            return { origin: event, id: job_id };
          })
        )
      )
      .asObservable()
      .pipe(
        filter(e => e.id === job_id),
        // tap(e=>console.log(e, job_id), e=>console.log(e, job_id)),
        takeWhileInclusive(e => this.isToggleInSession(e, job_id)),
        map(e => e.origin),
        catchError(e => of(e.origin))
      );
    return job;
  }
  private isToggleInSession(e: { origin: any; id }, job_id: string): boolean {
    return (
      e.id === job_id &&
      e.origin.type !== ToggleEventTypes.ToggleFailed &&
      e.origin.type !== ToggleEventTypes.ToggleSucceeded
    );
  }
}
